/** URLs da API usadas pela tela Expedição (centralização sem mudar contratos). */

export const expedicaoEndpoints = {
  list: "/api/expedicao",
  cargaMeioTranspAjudante: "/api/expedicao/carga/ajudante",
  reenviaritrack: "/api/expedicao/reenviaritrack",
  gerarDocumentos: (shipmentId) =>
    `/api/expedicao/gerar-documentos/${shipmentId}`,
  reenviotrndocfis: "/api/expedicao/reenviotrndocfis",
  reenviaritrackmdfe: "/api/expedicao/reenviaritrackmdfe",
  store: "/api/expedicao/store",
  romaneioImprimir: "/api/gerenciamentotransporte/romaneio/imprimir",
  romaneioProvisorioImprimir:
    "/api/gerenciamentotransporte/romaneio-provisorio/imprimir",
  mdfeImprimir: "/api/mdfe/imprimir",
  montagemCargaCancelar: "/api/montagemcarga/cancelar",
  jsonlistgeral: "/api/expedicao/jsonlistgeral",
  jsonlistsimple: "/api/expedicao/jsonlistsimple",
  agrupar: "/api/expedicao/agrupar",
  desagrupar: "/api/expedicao/desagrupar",
  mdferomaneio: "/api/expedicao/mdferomaneio",
  calculoEstornar: "/api/expedicao/calculo/estornar",
  cancelarNstech: (cargaId) => `/api/nstech/cancelar-carga/${cargaId}`,
  geraciot: "/api/expedicao/geraciot",
  cancelar: "/api/expedicao/cancelar",
  integracaoManual: "/api/expedicao/integracao/manual",
};
